import React, { FC, useState } from "react";
import { Modal, Row, Col, Collapse } from "antd";
import _ from "lodash";
import { Form, Input, Button } from "antd";
import { FormLabel } from "react-bootstrap";
const { Panel } = Collapse;

const WelcomeModal: FC<{
  onClose: () => void;
  message: string;
}> = ({ onClose, message }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [confirmation] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  const handleCancel = () => {};

  return (
    <Modal
      title="Welcome to inStore call center"
      visible={true}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
      closable={false}
    >
      <Form
        className="auth-form"
        name="confirmation-form"
        id="confirmation-form"
        layout="vertical"
        form={confirmation}
        requiredMark={false}
      >
        <Form.Item
          name="password"
          rules={[{ required: true, message: "**Required Field" }]}
          className="mt-3"
        >
          <FormLabel>{message || "Are you sure you want to continue?"}</FormLabel>
        </Form.Item>

        <Form.Item className="action-grp mt-4">
          <Row>
            <Col span={14} className="pr-2">
              <Button
                loading={loading}
                className="beam-btn green-btn cover w-full"
                onClick={()=>{
                  onClose && onClose();
                }}
              >
                Confirm
              </Button>
            </Col>
            <Col span={10} className="pl-2">
              <Button
                className="beam-btn orange-btn bordered w-full"
                onClick={()=>{
                  window.close();
                }}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default WelcomeModal;
